<template>
  <jw-breadcrumb>
    <template #separator>
      <icon-right />
    </template>
    <jw-breadcrumb-item>
      <jw-link @click="router.replace({ name: pName, params: params })" :title="pText" class="sub-text">{{ pText }}</jw-link>
    </jw-breadcrumb-item>
    <jw-breadcrumb-item>
      <span :title="subText" class="sub-text">{{ subText }}</span>
    </jw-breadcrumb-item>
  </jw-breadcrumb>
</template>

<script setup>
import { useRouter } from 'vue-router';
defineProps({
  pName: { type: String },
  params: { type: Object },
  pText: { type: String },
  subText: { type: String }
});
const router = useRouter();
</script>
<style scoped lang="less">
@import './xl-breadcrumb.less';
</style>
